import { render, staticRenderFns } from "./OverallBudget.vue?vue&type=template&id=56190554&scoped=true&"
import script from "./OverallBudget.vue?vue&type=script&lang=js&"
export * from "./OverallBudget.vue?vue&type=script&lang=js&"
import style0 from "./OverallBudget.vue?vue&type=style&index=0&id=56190554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56190554",
  null
  
)

export default component.exports